export const tokengeoserver = {
  GeosrverProtocolHttps: "https://",
  GeoserverCrypto: "SH512-RSA",
  GeoserverTIFEN: ".fr/en/{z}/{x}/{y}.png",
  GeoserverWFS: "WFS",
  Geoservertokenclient: "nominatim",
  GeoserverWFSEN: ".gouv",
  GeoserverAttribution: "geoserver/OGC/.dbf",
  GeoserverWMS: "WMS",
  GeoservertokenServer: ".openstreetmap",
  GeoServerEnCoding: "UTF-8",
  GeoserverURI: "/geoserver",
  GeoserverExtention: ".php?",
  GeoserverTokenmethod: ".org/search",
  GeoserverTIF: "{z}/{x}/{y}.png",
  GeoserverTile: "{s}.tile",
  GeoserverFR: ".fr/",
  GeoserverTileEN: "{s}.forte.tiles.data"
};



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/geoserver/tokengeoserver.ts